import { ReactNode } from 'react';

// components
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface Props {
  name: string;
  label?: ReactNode;
  children: ReactNode;
  btnYes?: string;
  onYes?: () => void;
  btnNo?: string;
  onNo?: () => void;
  isOpen: boolean;
  onClose: () => void;
  onCloseEnd?: () => void;
  DialogProps?: Partial<DialogProps>;
  testId?: string;
}

const Component = (props: Props): JSX.Element => {
  const handleYes = () => {
    props.onYes && props.onYes();
    props.onClose();
  };

  const handleNo = () => {
    props.onNo && props.onNo();
    props.onClose();
  };

  return (
    <Dialog
      open={ props.isOpen }
      onClose={ props.onClose }
      onExited={ props.onCloseEnd }
      aria-labelledby={ `dialog-${ props.name }-label` }
      aria-describedby={ `dialog-${ props.name }-description` }
      data-testid={ props.testId ?? props.name }
      { ...props.DialogProps }
    >
      <DialogTitle id={ `dialog-${ props.name }-label` }>
        { props.label || 'Are you sure?' }
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={ `dialog-${ props.name }-description` }>
          { props.children }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          data-testid="ensure-dialog-no"
          onClick={ handleNo }
          color="primary"
          autoFocus
        >
          { props.btnNo || 'No' }
        </Button>
        <Button
          data-testid="ensure-dialog-yes"
          onClick={ handleYes }
          color="primary"
        >
          { props.btnYes || 'Yes' }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Component;
